import React from "react";

import { Logo } from "components";
import {
  Button,
  Container,
  Icon,
  Label,
  Menu,
  MenuItem,
  MenuMenu,
} from "semantic-ui-react";
import { AppService } from "services";
import { Link, useNavigate } from "react-router-dom";

export const Header: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    AppService.processLogout();
    navigate("/login");
  };
  return (
    <Container fluid>
      <Menu stackable style={{ position: "sticky" }}>
        <Container>
          <MenuItem>
            <Logo
              as={Link}
              to="/"
              style={{ objectFit: "contain", height: "30px", width: "100px" }}
            />
          </MenuItem>

          <MenuMenu position="right">
            <MenuItem name="auth">
              <Label
                style={{ marginRight: "1rem" }}
                as="div"
                circular
                color="black"
              >
                <Icon disabled name="user outline" size="large" inverted />
                {AppService.getUsername()}
              </Label>
              <Button onClick={handleLogout}>Déconnexion</Button>
            </MenuItem>
          </MenuMenu>
        </Container>
      </Menu>
    </Container>
  );
};
